export const getUtmData = () => {
  const params = new URLSearchParams(window.location.search);

  const utmData = {
    utmSource:
      params.get("utm_source") || localStorage.getItem("utm_source") || "",
    utmMedium:
      params.get("utm_medium") || localStorage.getItem("utm_medium") || "",
    utmCampaign:
      params.get("utm_campaign") || localStorage.getItem("utm_campaign") || "",
    utmTerm: params.get("utm_term") || localStorage.getItem("utm_term") || "",
    utmContent:
      params.get("utm_content") || localStorage.getItem("utm_content") || "",
    referrer: document.referrer || localStorage.getItem("referrer") || "",
    promoName: localStorage.getItem("promoName") || "",
    promoPosition: localStorage.getItem("promoPosition") || "",
    promoCreative: localStorage.getItem("promoCreative") || "",
  };

  Object.entries(utmData).forEach(([key, value]) => {
    if (value) localStorage.setItem(key, value);
  });

  return utmData;
};
